module.exports = new __parcel__URL__("open-hihat_7.f7c80852.mp3").toString();